export default __webpack_public_path__ + "static/media/icon_cancel_success.ed995ecd.png";